<template>
  <div class="deliveryTimeConfiguration" v-loading="loading">
    <div class="header">
      <div class="filter">
        <div v-if="deptId === '127'" class="filter_item">
          <div class="filter_item_label">医馆名称：</div>
          <el-select class="filter_item_value" v-model="form.toDeptId" clearable placeholder="请选择">
            <el-option
              v-for="item in deptList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="filter_item">
          <div class="filter_item_label">加工方式：</div>
          <el-select class="filter_item_value" v-model="form.handlingWay" clearable placeholder="请选择">
            <el-option
              v-for="item in processList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-button class="filter_btn" type="primary" @click="search">查询</el-button>
        <el-button class="filter_btn" @click="reset">重置</el-button>
      </div>
      <div class="file_operation">
        <el-button class="file_btn" type="primary" :loading="uploading" @click="importConfig">导入</el-button>
        <el-button class="file_btn" type="primary" @click="exportConfig">导出</el-button>
        <input ref="importInput" class="file_import_input" type="file" accept=".xls,.xlsx" @change="importChange"></input>
      </div>
    </div>
    <div class="config_list">
      <div class="section">
        <div class="section_title">自提单</div>
        <el-table
          class="section_table"
          max-height="530"
          :data="pickUpConfigMap.list"
          border>
          <el-table-column type="index" :index="pickUpConfigIndex" label="序号" width="50"></el-table-column>
          <el-table-column prop="acceptStartDateTime" label="收方开始时间" min-width="120"></el-table-column>
          <el-table-column prop="acceptEndDateTime" label="收方结束时间" min-width="120"></el-table-column>
          <el-table-column prop="handlingWayName" label="加工方式" min-width="100"></el-table-column>
          <el-table-column v-if="deptId !== '127'" prop="oneselfPickUpTime" label="预计自提时间" min-width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.oneselfPickUpDay === 1 ? `当天 ${ scope.row.oneselfPickUpTime }` : `第${ scope.row.oneselfPickUpDay }天 ${ scope.row.oneselfPickUpTime }` }}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="deptId === '127'" prop="toDeptName" label="自提医馆" min-width="100"></el-table-column>
          <el-table-column v-if="deptId === '127'" prop="oneselfPickUpTime" label="预计送回到馆时间" min-width="140">
            <template slot-scope="scope">
              <div>{{ scope.row.oneselfPickUpDay === 1 ? `当天 ${ scope.row.oneselfPickUpTime }` : `第${ scope.row.oneselfPickUpDay }天 ${ scope.row.oneselfPickUpTime }` }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="section_pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pickUpConfigMap.total"
            :current-page="pickUpConfigMap.pageNo"
            :page-size="pickUpConfigMap.pageSize"
            @current-change="pickUpConfigPageNoChange">
          </el-pagination>
        </div>
      </div>

      <div class="section">
        <div class="section_title">配送单</div>
        <el-table
          class="section_table"
          max-height="530"
          :data="deliveryConfigMap.list"
          border>
          <el-table-column type="index" :index="deliveryConfigIndex" label="序号" width="50"></el-table-column>
          <el-table-column prop="acceptStartDateTime" label="收方开始时间" min-width="120"></el-table-column>
          <el-table-column prop="acceptEndDateTime" label="收方结束时间" min-width="120"></el-table-column>
          <el-table-column prop="handlingWayName" label="加工方式" min-width="100"></el-table-column>
          <el-table-column v-if="deptId === '127'" prop="toDeptName" label="收费医馆" min-width="100"></el-table-column>
          <el-table-column prop="deliveryTime" label="预计发货时间" min-width="120">
            <template slot-scope="scope">
              <div>{{ scope.row.deliveryDay === 1 ? `当天 ${ scope.row.deliveryTime }` : `第${ scope.row.deliveryDay }天 ${ scope.row.deliveryTime }` }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="section_pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="deliveryConfigMap.total"
            :current-page="deliveryConfigMap.pageNo"
            :page-size="deliveryConfigMap.pageSize"
            @current-change="deliveryConfigPageNoChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Upload from "@/components/Upload/Upload";
  import {
    getEffectiveDeptList,
    getDeliveryTimeConfigList,
    importDeptDeliveryTimeConfig,
    exportDeptDeliveryTimeConfig,
    importPharmacyDeliveryTimeConfig,
    exportPharmacyDeliveryTimeConfig
  } from "@/api/hospital"

  export default {
    name: "DeliveryTimeConfiguration",
    components: { Upload },
    data () {
      return {
        loading: false,
        uploading: false,
        deptId: '',
        deptName: '',
        deptList: [],
        processList: [
          {
            value: '0',
            label: '不加工'
          },
          {
            value: '1',
            label: '熬药'
          },
          {
            value: '2',
            label: '制膏'
          },
          {
            value: '3',
            label: '制丸'
          },
          {
            value: '4',
            label: '制粉'
          },
          {
            value: '5',
            label: '加工-YL'
          }
        ],
        form: {
          toDeptId: '',
          handlingWay: ''
        },
        pickUpConfigMap: {
          allList: [],
          pageNo: 1,
          pageSize: 10,
          list: [],
          total: 0,
        },
        deliveryConfigMap: {
          allList: [],
          pageNo: 1,
          pageSize: 10,
          list: [],
          total: 0,
        }
      }
    },
    created () {
      this.getDeptList()
      const deptInfo = sessionStorage.getItem('deptInfo') && JSON.parse(sessionStorage.getItem('deptInfo'))
      this.deptId = deptInfo.deptId.toString()
      this.deptName = deptInfo.deptName
      if (this.deptId !== '127') {
        this.form.toDeptId = this.deptId
      }
      this.getConfigList()
    },
    methods: {
      async getDeptList () {
        const res = await getEffectiveDeptList({ deptId: 'all' })
        if (res.code === 200) {
          this.deptList = res.data.map(item => {
            return {
              value: item.deptId.toString(),
              label: item.deptName
            }
          })
        }
      },
      async getConfigList () {
        const res = await getDeliveryTimeConfigList({
          toDeptId: this.form.toDeptId,
          handlingWay: this.form.handlingWay
        })
        if (res.code === 200) {
          let pickUpList = []
          let deliveryList = []

          res.data.forEach(v => {
            const process = this.processList.find(item => { return item.value === v.handlingWay.toString() })
            v['handlingWayName'] = process ? process.label : ''
            if (v.configType === 1) {
              pickUpList.push(v)
            }
            if (v.configType === 2) {
              deliveryList.push(v)
            }
          })

          this.pickUpConfigMap.allList = pickUpList
          this.pickUpConfigMap.list = pickUpList.slice(0, this.pickUpConfigMap.pageSize)
          this.pickUpConfigMap.total = pickUpList.length
          this.deliveryConfigMap.allList = deliveryList
          this.deliveryConfigMap.list = deliveryList.slice(0, this.deliveryConfigMap.pageSize)
          this.deliveryConfigMap.total = deliveryList.length
        }
      },
      pickUpConfigIndex (index) {
        return (this.pickUpConfigMap.pageNo - 1) * this.pickUpConfigMap.pageSize + index + 1
      },
      deliveryConfigIndex (index) {
        return (this.deliveryConfigMap.pageNo - 1) * this.deliveryConfigMap.pageSize + index + 1
      },
      pickUpConfigPageNoChange (pageNo) {
        this.pickUpConfigMap.pageNo = pageNo
        this.pickUpConfigMap.list = this.pickUpConfigMap.allList.slice((pageNo - 1) * this.pickUpConfigMap.pageSize, pageNo * this.pickUpConfigMap.pageSize)
      },
      deliveryConfigPageNoChange (pageNo) {
        this.deliveryConfigMap.pageNo = pageNo
        this.deliveryConfigMap.list = this.deliveryConfigMap.allList.slice((pageNo - 1) * this.deliveryConfigMap.pageSize, pageNo * this.deliveryConfigMap.pageSize)
      },
      async importConfig () {
        this.$refs['importInput'].click()
      },
      async importChange (e) {
        const file = e.target.files[0]

        const formData = new FormData()
        formData.append('deptId', this.deptId)
        formData.append('file', file)

        let res = null
        this.uploading = true

        if (this.deptId !== '127') {
          res = await importDeptDeliveryTimeConfig(formData)
        } else {
          res = await importPharmacyDeliveryTimeConfig(formData)
        }

        this.uploading = false

        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            let text = '解析失败，请按照提示修改表格后重新导入：'
            res.data.forEach(v => {
              text += `\n第${v.row}行第${v.col}列，${v.error}`
            })
            this.$confirm(text, '提示', {
              customClass: 'deliveryTimeConfiguration_confirm',
              confirmButtonText: '确定',
              showCancelButton: false,
              showClose: false,
              closeOnClickModal: false,
              closeOnPressEscape: false
            }).then(() => {}).catch(() => {})
          } else {
            this.$message.success('导入成功')
            this.getConfigList()
          }
        }

        this.$refs['importInput'].value = ''
      },
      async exportConfig () {
        this.loading = true
        let res = null
        if (this.deptId !== '127') {
          res = await exportDeptDeliveryTimeConfig({ deptId: this.deptId }, { name: `${this.deptName}自提/发货时间配置` })
        } else {
          res = await exportPharmacyDeliveryTimeConfig({ deptId: this.deptId }, { name: `${this.deptName}自提/发货时间配置` })
        }
        this.loading = false
        this.$message.success('导出成功')
      },
      search () {
        this.getConfigList()
      },
      reset () {
        if (this.deptId !== '127') {
          this.form.toDeptId = this.deptId
        } else {
          this.form.toDeptId = ''
        }
        this.form.handlingWay = ''
        this.getConfigList()
      }
    }
  }
</script>

<style lang="less" scoped>
  .deliveryTimeConfiguration {
    width: 100%;
    min-width: 0;
  }

  .header {
    width: 100%;
  }

  .filter {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  .filter_item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .filter_item+.filter_item {
    margin: 0 0 0 12px;
  }

  .filter_item_label {
    line-height: 32px;
    font-size: 14px;
    color: #1f2329;
  }

  .filter_item_value {
    width: 180px;
  }

  .filter_btn {
    margin: 0 0 0 12px;
  }

  .file_operation {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .file_btn+.file_btn {
    margin: 0 0 0 12px;
  }

  .file_import_input {
    display: none;
  }

  .config_list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
    margin: 24px 0 0 0;
    width: 100%;
  }

  .section {
    // margin: 24px 0 0 0;
    // width: 50%;
  }

  .section_title {
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #1f2329;
  }

  .section_table {
    margin: 12px 0 0 0;
    width: 100%;
  }

  .section_pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }
</style>

<style lang="less">
  .deliveryTimeConfiguration_confirm .el-message-box__message {
    max-height: 240px;
    white-space: pre-line;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>
